export const getLabelTranslation = (tenant?: string) => {
  switch (tenant) {
    case "GN":
      return "username";
    case "TN":
      return "texasNetEmail";
    case "GF":
    default:
      return "email";
  }
};
